import store from '../../../store/sellsyaccountmanager/global';

export default {
    created() {
        // Init store
        this.$store.registerModule('global', store);
    },
}